import { render, staticRenderFns } from "./Datefield.vue?vue&type=template&id=0f2005df&"
import script from "./Datefield.vue?vue&type=script&lang=js&"
export * from "./Datefield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports